import React, { Component } from "react";
import Scrollbars from "react-custom-scrollbars";
import "../../assets/css/storage/storageView.css";
import StorageService from '../../services/api/Storage/index.js';
import { MESSAGE_OFFLINE, notebookEditorData, OFFLINE } from "../../settings/shared/constants";
import LoaderOverlay from "../../components/LoadingOverlay.js";
import notFound from "../../assets/img/notFound.png";
import withNavigate from "../../components/withNavigate.js";
import DocumentViewer from "../../components/DocViewer/DocumentViewer.js";
import JsonRender from "../../components/DocViewer/JsonRender.js";
import { uuidv4 } from "../../settings/shared/commonMethods.js";
import { SANotification } from "../../components/SANotification.js";
import axios from "axios";
import MarkDown from "../../components/Notebook/MarkDown.js";
import { CardBody, Col, Collapse, Row } from "react-bootstrap";
import CodeHighlight from "../../components/Notebook/CodeHighlight.js";
import { renderOutput } from "../../components/Notebook/Notebook.js";
import "../../assets/css/notebook.css";
import SATooltip from "../../components/common/SATooltip.js";

const STORAGE_VIEW_CSS = `
  .sa-sview-shell {
    padding: 14px 16px 18px;
    min-height: calc(100vh - 64px);
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 60%, #ffffff 100%);
  }

  .sa-sview-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(226,232,240,0.9);
    border-radius: 14px;
    box-shadow: 0 10px 26px rgba(15,23,42,0.06);
    backdrop-filter: blur(10px);
  }
  .sa-sview-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }
  .sa-sview-back {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid rgba(226,232,240,0.95);
    background: #fff;
    color: #0f172a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease;
    flex-shrink: 0;
  }
  .sa-sview-back:hover {
    transform: translateY(-1px);
    border-color: rgba(26,115,232,0.30);
    box-shadow: 0 12px 24px rgba(26,115,232,0.12);
  }
  .sa-sview-filemeta {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .sa-sview-filemeta .t {
    font-size: 14px;
    font-weight: 800;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 62vw;
    letter-spacing: -0.01em;
  }
  .sa-sview-filemeta .s {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 62vw;
  }
  .sa-sview-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .sa-sview-btn {
    width: 34px;
    height: 34px;
    border-radius: 999px;
    border: 1px solid transparent;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #475569;
    transition: background 0.12s ease, color 0.12s ease;
  }
  .sa-sview-btn:hover:not(:disabled) {
    background: rgba(0,0,0,0.06);
    color: #0f172a;
  }
  .sa-sview-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  .sa-sview-btn.primary:hover:not(:disabled) { background: rgba(26,115,232,0.12); color: #1a73e8; }

  .sa-sview-card {
    margin-top: 14px;
    background: rgba(255,255,255,0.96);
    border: 1px solid rgba(226,232,240,0.9);
    border-radius: 14px;
    box-shadow: 0 10px 26px rgba(15,23,42,0.06);
    overflow: hidden;
  }
  .sa-sview-card-head {
    padding: 12px 14px;
    border-bottom: 1px solid rgba(226,232,240,0.75);
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .sa-sview-card-head .label {
    font-size: 12px;
    font-weight: 900;
    color: #64748b;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .sa-sview-content {
    padding: 0;
  }
`;

class StorageView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: window.innerHeight,
            myContent: '',
            myContentChart: '',
            fileName: '',
            fileType: '',
            renderNotebook: '',
            myContents: [],
            DownloadUrl: '',
            delimiter: ',',
            delimiterName: ',',
            totalPages: 0,
            startIndex: 0,
            // pageRecords: NO_OF_RECORDS,
            activePage: 1,
            totalRecords: 0,
            showCode: false,
            openMark: [""],
            advanceicon: "fas fa-plus-circle",
            markoptions: [],
            storageId: "",
            rootFolder: "",
            storageName: "",
            platformDefault: false,
            errorFile: "",
            hideCode: "",
            contextMenuTable: false,
            showVersion: false,
            versionValue: false,
            listversion: [],
            showSaveModal: false,
            savecomments: '',
            showSavebutton: false,
            currentVersion: '',
            currentComments: '',
            showSaveasModal: false,
            fileToBeCreate: "",
            fileSize: '',
            smallfile: false,
            rowheader: false,
            showOriginal: false,
            hotSettings: [],
            readonlyTable: true,
            showHandsontable: false,
            versionName: null,
            NoData: false,
            savefrom: '',
            storageJobId: '',
            disableicon: false,
            jobState: '',
            count: 0,
            numPages: null,
            pdfPageNumber: 1,
            sheetName: [],
            keyValue: [],
            xlsxurl: '',
            getCopyText: false,
            csvData: [],
            btnNextState: false,
            isExistAnnotation: '',
            annotation: [],
            annotationIndex: [],
            copiedindex: '',
            identifier: '',
            tempFilePath: '',
            storageFileId: '',
            modalReloadStateConfirm: false,
            confirmLoading: false,
            modalSaveConfirm: false,
            fileSizeModal: false,
            col_l_freez: 0,
            row_t_freez: 0,
            row_b_freez: 0
        }
    }

    componentDidMount() {
        const url = window.location.href
        this.renderFileView();
        let myPath = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('file')
        document.title = "SuperAgentX - " + myPath;

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        // Inject view-scoped styles once (keep legacy storageView.css intact)
        const id = "sa-storage-view-styles";
        if (!document.getElementById(id)) {
            const tag = document.createElement("style");
            tag.id = id;
            tag.textContent = STORAGE_VIEW_CSS;
            document.head.appendChild(tag);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({
            height: window.innerHeight
        })
    }

    renderFileView = () => {
        var ext = "";
        this.setState({ loading: true, hotSettings: [] });
        const url = window.location.href
        let myPath = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('file')
        let sId = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('storage')
        let root = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('root')
        let storageName = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('storageName')
        let platformDefault = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('platformDefault')
        let hideCodeCells = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('hideCodeCells')
        let fileSize = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('filesize')
        let version = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('version')
        if (myPath === null) {
            const channelOffline = new BroadcastChannel(MESSAGE_OFFLINE);
            channelOffline.postMessage({ data: OFFLINE });
        } else {
            ext = myPath.substring(myPath.lastIndexOf(".") + 1)
        }
        this.setState({
            fileName: (myPath === null || myPath === undefined) ? "" : myPath,
            fileType: ext,
            storageId: (sId === null || sId === undefined) ? "" : sId,
            rootFolder: (root === null || root === undefined) ? "" : root,
            storageName: (storageName === null || storageName === undefined) ? "" : storageName,
            platformDefault: (platformDefault === null || platformDefault === undefined) ? false : (platformDefault === 'true' ? true : false),
            hideCode: hideCodeCells,
            fileSize: fileSize,
            loading: false
        })
        if (fileSize > 2097152) {
            this.setState({ smallfile: false })
        }
        else {
            this.setState({ smallfile: true })
        }

        if (typeof version === "string" && (version === null || version === "null")) {
            this.downloadObj(myPath, sId, root);
        } else if (typeof version === "object" && version === null) {
            this.downloadObj(myPath, sId, root);
        }
        // if (typeof version === "string" && (version === null || version === "null")) {
        //   this.downloadObj(myPath, sId, root);
        // } else if (typeof version === "string" && (version !== null || version !== "null")) {
        //   this.downloadVersionFiles(myPath, version, sId, root)
        // } else if (typeof version === "object" && version === null) {
        //   this.downloadObj(myPath, sId, root);
        // }
        // this.checkOriginalVersion(myPath, sId, root);
    }

    reloadFiles = () => {
        const url = window.location.href
        let version = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('version')
        let myPath = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('file')
        let sId = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('storage')
        let root = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('root')
        if (myPath === null) {
            const channelOffline = new BroadcastChannel(MESSAGE_OFFLINE);
            channelOffline.postMessage({ data: OFFLINE });
        }

        if (typeof version === "string" && (version === null || version === "null")) {
            this.downloadObj(myPath, sId, root);
        } else if (typeof version === "object" && version === null) {
            this.downloadObj(myPath, sId, root);
        }
        // if (typeof version === "string" && (version === null || version === "null")) {
        //   this.downloadObj(myPath, sId, root);
        // } else if (typeof version === "string" && (version !== null || version !== "null")) {
        //   this.downloadVersionFiles(myPath, version, sId, root)
        // } else if (typeof version === "object" && version === null) {
        //   this.downloadObj(myPath, sId, root);
        // }
    }

    downloadObj = (filePath, sId, root) => {
        if (filePath) {
            this.setState({ loading: true });
            StorageService.downloadObjectUrl(filePath, sId, root)
                .then((response) => {
                    if (response && response?.hasOwnProperty("download_url")) {
                        this.renderText(response?.download_url, filePath, sId, root);
                        this.setState({
                            DownloadUrl: response?.download_url,
                            loading: false
                        });
                    }
                }).catch((error) => {
                    this.setState(prevState => ({
                        ...prevState,
                        fileType: 'png',
                        myContent: notFound,
                        fileName: 'File Not Found!!!',
                        loading: false
                    }));
                });
        }
    }

    renderText = (url, filePath, storageId, rootFolder) => {
        this.setState({ loading: true });
        const supportedFileTypes = [
            "jpeg", "jpg", "png", "pdf", "pptx",
            "doc", "docx", "json", "xlsx", "xls", "csv"
        ];

        const fileType = this.state.fileType.toLowerCase();
        if (supportedFileTypes.includes(fileType)) {
            this.setState({
                myContent: url,
                loading: false
            });
        } else {
            this.getDataFromUrl(url);
        }
    }
    

    getDataFromUrl = (url) => {
        axios.get(url)
            .then(response => {
                if (this.state.fileType.toLowerCase() === "ipynb") {
                    let notebook = response.data
                    this.setState({
                        loading: false
                    }, () => {
                        this.getNotebookCellsData(notebook);
                    })
                } else if (this.state.fileType.toLowerCase() === "txt") {
                    this.setState({
                        fileType: "txt",
                        myContent: response.data.toString(),
                        loading: false
                    })
                } else if (this.state.fileType.toLowerCase() === "py") {
                    this.setState({
                        fileType: "py",
                        myContent: response.data.toString(),
                        loading: false
                    })
                }
                else {
                    this.setState({
                        fileType: "others",
                        myContent: response.data.toString(),
                        loading: false
                    })
                }
            });
    }

    getNotebookCellsData = (notebook) => {
        let options = []
        let opencell = []
        if (Array.isArray(notebook.cells)) {
            if (notebook.cells.length !== 0) {
                let count = 1;
                let contentid = 1;
                for (var i = 0; i < notebook.cells.length; i++) {
                    if (!notebook.cells[i].metadata.hasOwnProperty("sa_cell_id")) {
                        let metatab = { "sa_cell_id": uuidv4() }
                        notebook.cells[i].metadata = metatab
                    }
                    if (notebook.cells[i].cell_type === "code") {
                        notebook.cells[i].metadata.codeindex = count++;
                        opencell.push({
                            name: notebook.cells[i].metadata.sa_cell_id,
                        })
                        this.setState(prevState => ({
                            ...prevState,
                            opencellid: opencell
                        }));
                    }
                    if (notebook.cells[i].cell_type === "markdown") {
                        if (typeof (notebook.cells[i].source) === "string") {
                            if (notebook.cells[i].source.substring(0, 20).includes('#')) {
                                options.push({
                                    name: notebook.cells[i].source,
                                })
                                notebook.cells[i].metadata.contentid = contentid++;
                                this.setState(prevState => ({
                                    ...prevState,
                                    markoptions: options
                                }));
                            }
                        }
                        if (typeof (notebook.cells[i].source) === "object") {
                            let notebookCell = notebook.cells[i].source;
                            if (notebookCell.length > 0) {
                                if (notebookCell[0].toString().substring(0, 20).includes('#')) {
                                    options.push({
                                        name: notebookCell[0],
                                    })
                                    notebook.cells[i].metadata.contentid = contentid++;
                                    this.setState(prevState => ({
                                        ...prevState,
                                        markoptions: options
                                    }));
                                }
                            }
                        }
                    }
                }
            }
            this.setState({
                myContent: notebook.cells,
                loading: false
            }, () => {
                if (this.state.hideCode === "true") {
                    this.closeMarkToggle();
                    this.setState({ showCode: false })
                }
                else {
                    this.expandMarkToggle();
                    this.setState({ showCode: true })
                }
            })
        } else {
            SANotification({ type: "error", message: "Invalid Notebook" });
            this.setState(prevState => ({
                ...prevState,
                fileType: 'png',
                myContent: notFound,
                loading: false
            }));
        }
    }

    expandMarkToggle = () => {
        let codelength = this.state.opencellid;
        let allcode = []
        for (var j = 0; j < codelength.length; j++) {
            allcode.push(codelength[j].name)
        }
        this.setState({
            openMark: allcode,
        });
    }

    closeMarkToggle = () => {
        this.setState({
            openMark: [],
        });
    }

    navigateToStorage = () => {
        this.props.navigate("/storage");
    }

    downloadparticularFiles = (fileName) => {
        StorageService.downloadObjectUrl(fileName, this.state.storageId, this.state.rootFolder)
            .then((response) => {
                const link = document.createElement('a');
                link.href = response.download_url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
    }

    renderer = (instance, TD, row, col, prop, value, cellProperties) => {
        TD.innerHTML = "";
        if (value) {
            if (row === 0) {
                TD.className = 'headercolor'
                TD.innerHTML = value;
            } else {
                TD.className = 'gray'
                TD.innerHTML = value;
            }
        }
        return TD;
    };

    collapsesMarkToggle = (collapse) => {
        let openMark = this.state.openMark;
        if (openMark.includes(collapse)) {
            this.setState({
                openMark: [],
            });
        } else {
            this.setState({
                openMark: [collapse],
            });
        }
    };

    handlerangeClick = (e, name, index) => {
        this.setState({ getCopyText: true, copiedindex: index })
        setTimeout(() => {
            this.setState({ getCopyText: false })
        }, 3000);
        switch (e.detail) {
            case 1:
                // single click event 
                this.onCopyOutputClick(name, index);
                break;
            default:
                break;
        }
    };

    onCopyOutputClick = (name, index) => {
        var range = document.createRange();
        range.selectNode(document.getElementById("outputContents" + index));
        window.getSelection().removeAllRanges(); // clear current selection
        window.getSelection().addRange(range); // to select text
        document.execCommand("copy");
        window.getSelection().removeAllRanges();// 
    }

    scrollToNode = (node) => {
        const titleElement = document.getElementById(node)
        titleElement?.scrollIntoView({ behavior: 'smooth' })
        this.setState(prevState => ({
            ...prevState,
            clickId: node
        }));
    }

    render() {
        const fileNameShort = (this.state.fileName || "").split("/").pop() || this.state.fileName || "File";
        const storageLabel = this.state.storageName ? `${this.state.storageName}${this.state.rootFolder ? ` · ${this.state.rootFolder}` : ""}` : "Storage";

        return (
            <>
                <div className="sa-sview-shell">
                    <div className="sa-sview-topbar">
                        <div className="sa-sview-left">
                            <button
                                type="button"
                                className="sa-sview-back"
                                onClick={this.navigateToStorage}
                                aria-label="Back to storage"
                                title="Back to storage"
                            >
                                <i className="fa-solid fa-arrow-left" aria-hidden="true" />
                            </button>

                            <div className="sa-sview-filemeta">
                                <div className="t" title={this.state.fileName || fileNameShort}>
                                    {fileNameShort}
                                </div>
                                <div className="s" title={storageLabel}>
                                    {storageLabel}
                                </div>
                            </div>
                        </div>

                        <div className="sa-sview-actions">
                            <SATooltip title="Download" placement="bottom">
                                <button
                                    type="button"
                                    className="sa-sview-btn primary"
                                    disabled={this.state.disableicon === true || !this.state.fileName}
                                    onClick={() => this.downloadparticularFiles(this.state.fileName)}
                                    aria-label="Download"
                                >
                                    <i className="fas fa-download" aria-hidden="true" />
                                </button>
                            </SATooltip>
                            <SATooltip title="Refresh" placement="bottom">
                                <button
                                    type="button"
                                    className="sa-sview-btn"
                                    onClick={this.reloadFiles}
                                    aria-label="Refresh"
                                >
                                    <i className="fas fa-sync" aria-hidden="true" />
                                </button>
                            </SATooltip>
                            <SATooltip title="Close" placement="bottom">
                                <button
                                    type="button"
                                    className="sa-sview-btn"
                                    onClick={this.navigateToStorage}
                                    aria-label="Close"
                                >
                                    <i className="fa-solid fa-xmark" aria-hidden="true" />
                                </button>
                            </SATooltip>
                        </div>
                    </div>

                    <div className="sa-sview-card">
                        <div className="sa-sview-card-head">
                            <span className="label">Preview</span>
                            <span className="label" style={{ fontWeight: 700, letterSpacing: 0.02, textTransform: "none" }}>
                                {this.state.fileType ? this.state.fileType.toUpperCase() : ""}
                            </span>
                        </div>

                        <div className="sa-sview-content d-flex">
                        {this.state.fileType.toLowerCase() === "ipynb" && this.state.markoptions?.length > 0 && <div className="ipynb-tab-content w-25 px-3">
                            <Scrollbars autoHeight autoHeightMin={this.state.height - 150} autoHeightMax={this.state.height - 150}>
                                <h5 className="tblofcontent">Table of Content</h5>
                                {this.state.markoptions !== "" && this.state.markoptions?.map((itm, ind) => (
                                    <Row className="action-pointer">
                                        <ol start={ind + 1}>
                                            <li>
                                                <div onClick={() => this.scrollToNode(ind + 1)} className={this.state.clickId === ind + 1 ? 'activeLink markdiv' : 'markdiv'} >
                                                    <MarkDown markdownValue={itm.name} className="markdwntxt" ></MarkDown>
                                                </div>
                                            </li>
                                        </ol>

                                    </Row>
                                ))}
                            </Scrollbars>
                        </div>}
                        <div className="w-100">
                            <Scrollbars autoHeight autoHeightMin={this.state.height - 150} autoHeightMax={this.state.height - 150}>
                                {(
                                    this.state.fileType &&
                                    ["jpeg", "jpg", "png"].includes(this.state.fileType.toLowerCase())
                                ) && (
                                        <img
                                            src={this.state.myContent}
                                            alt="uploaded preview"
                                            className="d-block m-auto py-4"
                                        />
                                    )}
                                {((this.state.fileType.toLowerCase() === "pdf") ||
                                    (this.state.fileType.toLowerCase() === "ppt") ||
                                    (this.state.fileType.toLowerCase() === "pptx") ||
                                    (this.state.fileType.toLowerCase() === "doc") ||
                                    (this.state.fileType.toLowerCase() === "docx") ||
                                    this.state.fileType.toLowerCase() === "xlsx" ||
                                    this.state.fileType.toLowerCase() === "xls" ||
                                    this.state.fileType.toLowerCase() === "csv") &&
                                    <DocumentViewer
                                        myContent={this.state.myContent}
                                        type={this.state.fileType}
                                        height={this.state.height - 150}
                                    />
                                }
                                {this.state?.myContent && this.state?.fileType.toLowerCase() === "json" &&
                                    <JsonRender urlData={this.state.myContent} />
                                }
                                {this.state?.myContent && this.state.fileType.toLowerCase() === "txt" &&
                                    <pre className="font13 p-3">{this.state.myContent ?? "No Data"}</pre>
                                }
                                {this.state.fileType.toLowerCase() === "ipynb" &&
                                    <div id="notebookDiv" className="mt-3 px-3">
                                        {this.state?.myContent && this.state.myContent?.map((item, index) => (
                                            <div key={index} id={item?.metadata?.contentid}>
                                                {/* if cell type is mark down */}
                                                {item.cell_type === "markdown" &&
                                                    // <div ref={(node) => item?.metadata?.contentid = node} >
                                                    <div>
                                                        <div className="displaytxt pt-3">
                                                            <MarkDown
                                                                markdownValue={item?.source}
                                                                id={item?.metadata?.sa_cell_id}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {/* if cell type is code */}
                                                {item.cell_type === "code" &&
                                                    <div
                                                        aria-multiselectable={true}
                                                        className="card-collapse"
                                                        id="accordion"
                                                        role="tablist"
                                                    >
                                                        <a
                                                            aria-expanded={this.state.openMark.includes(
                                                                item.metadata.sa_cell_id
                                                            )}
                                                            href="#pablo"
                                                            data-parent="#accordion"
                                                            data-toggle="collapse"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                this.collapsesMarkToggle(item.metadata.sa_cell_id, this.state.openMark.includes(
                                                                    item.metadata.sa_cell_id
                                                                ));
                                                            }}
                                                        >
                                                            <Row className="align-items-center m-0 p-0">
                                                                <div className="col-12 col-sm-10 m-0 p-0">
                                                                    <div className="hrdiv">
                                                                        <span className="hrtext">
                                                                            Code
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-2 text-right">
                                                                    <span className="pr-1" >
                                                                        [ {item.metadata.codeindex} ]
                                                                    </span> <i className={this.state.openMark.includes(item.metadata.sa_cell_id) === false ? "fas fa-plus-circle" : "fas fa-minus-circle"}></i>
                                                                </div>
                                                            </Row>
                                                        </a>
                                                        <Collapse
                                                            className="pt-2"
                                                            role="tabpanel"
                                                            in={this.state.openMark.includes(
                                                                item.metadata.sa_cell_id
                                                            )}
                                                        >
                                                            <CardBody>
                                                                <Row className="m-0 p-0">
                                                                    <Col xs="12" className="code-highlight-top m-0 p-0">
                                                                        <div>
                                                                            <CodeHighlight
                                                                                codeValue={item.metadata.hasOwnProperty("df_sql") ? item.metadata.df_query_str : item.source}
                                                                                data={item}
                                                                                language_mode={item.metadata.hasOwnProperty("df_sql") ? "mysql" : "python"}
                                                                                output={item.outputs}
                                                                                language={this.state.lang}
                                                                                flagId={this.state.codeFlag}
                                                                                editorSettingsData={notebookEditorData}
                                                                                index={index}
                                                                                readOnly={true}
                                                                                _getNewCode={this._getNewCode}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Collapse>
                                                        <Row className="outputmargin m-0 p-0">
                                                            <div className="displaytxt col-12 m-0 p-0">
                                                                {item.outputs.length > 0 && <div className="outputBorder">
                                                                </div>}
                                                                {item.outputs.length > 0 && <div className="displaytxt col-12">
                                                                    <span title="Click To Copy" className="clickcopy float-right p-2 rounded copy-icon action-pointer">
                                                                        <span className={this.state.copiedindex === index ? this.state.getCopyText ? "copiedBack" : "" : ""}>{this.state.copiedindex === index ? this.state.getCopyText ? <span><i className="fa-solid fa-check text-success"></i> Copied</span> : "" : ""
                                                                        }</span>
                                                                        <i className="fas fa-copy" onClick={e => this.handlerangeClick(e, renderOutput(item.outputs), index)}></i></span>
                                                                    <pre><code><div id={"outputContents" + index} dangerouslySetInnerHTML={{ __html: renderOutput(item.outputs) }}></div></code></pre>
                                                                </div>}
                                                            </div>
                                                        </Row>
                                                    </div>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                                {this.state?.myContent &&  this.state.fileType.toLowerCase() === "py" &&
                                    <pre className="othercontentpara p-3 python">
                                        {this.state.myContent}
                                    </pre>}
                                {this.state?.myContent && this.state.fileType === "others" &&
                                    <p className="othercontentpara p-3">
                                        {this.state.myContent}
                                    </p>
                                }
                            </Scrollbars>
                        </div>
                        </div>
                    </div>

                    <LoaderOverlay loading={this.state.loading} />
                </div>
            </>
        )
    }
}

export default withNavigate(StorageView);